import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { AuthUser } from '@classes/auth/auth-user';
import { environment } from '@environments/environment';
import { faCar } from '@fortawesome/free-solid-svg-icons';
import { AuthService } from '@services/auth/auth.service';

@Component({
  selector: 'app-main-header',
  templateUrl: './main-header.component.html',
  styleUrls: ['./main-header.component.scss']
})
export class MainHeaderComponent implements OnInit, OnChanges {

  @Input() isAuth: boolean;
  @Output() sidenavToggle = new EventEmitter<void>();

  faCar = faCar;

  appName: string = environment.appName;
  appVersion: string = environment.version;

  user: AuthUser;

  constructor(
    private authService: AuthService
  ) { }

  ngOnInit(): void {
  }

  ngOnChanges(): void {
    if (this.isAuth) {
      this.user = this.authService.getUser();
    } else {
      this.user = null;
    }
  }

  onToggleSidenav(): void {
    this.sidenavToggle.emit();
  }

}
